module.exports = __webpack_public_path__ + "uia-skip-rights.d04af07bc08f16669f8631f9422ada96.svg";